import React from 'react'
import PropTypes from 'prop-types'

import './RailHeading.scss'

const RailHeading = (props) => (
  <div
    {...props}
    className="visits-rail-heading-comp"
  ></div>
)

RailHeading.propTypes = {
  children: PropTypes.any.isRequired,
}

export default RailHeading
